export const RECORD_BLUE = '#2154E8';

export const PALETTE = {
  ink: '#1B2220',
  muted: '#6E7A77',
  faint: '#9AA5A2',
  line: '#E3E7E5',
  panel: '#F7F9F8',
  brand: '#4E7A34',
  brandDark: '#3D6128',
  brandTint: '#F2F7EE',
  brandBorder: '#C6DDB6',
  amber: '#C98A12',
  lateBg: '#FDF6E4',
  lateBorder: '#E8CF7A',
  lateTagBg: '#FFF6D8',
  lateText: '#7A5405',
  recordBg: '#EDF1F6',
  recordBorder: '#C6D2DF',
  recordText: '#31465E'
};

export const RECORD_BAR_HEIGHT = 44;

export const STONE_CLASSES = [
  { key: 's', label: 'Under 15 cm', color: '#E6C888', chipColor: '#B99442', radius: 5 },
  { key: 'm', label: '15–30 cm', color: '#EFA033', radius: 5.8 },
  { key: 'l', label: '30–50 cm', color: '#DE6B2E', radius: 6.6 },
  { key: 'xl', label: 'Over 50 cm', color: '#C9342B', radius: 7.8 }
];

export const NEUTRAL_STONE_CLASS = {
  key: 'unknown',
  label: 'Size not known',
  color: '#8A9390',
  radius: 4.2
};

export const PICK_LIST_DEFAULT_CAP = 0.7;
export const PICK_LIST_SWEET_SPOT = 0.7;
export const CAP_MIN = 0.05;
export const CAP_STEP = 0.05;
export const CAP_FLOOR_MAX = 0.2;
export const MUST_PICK_CM_MIN = 5;
export const MUST_PICK_CM_MAX = 150;

export const MUST_PICK_COLOR = '#D32A20';
export const OPTIONAL_PICK_COLOR = '#F0B400';

export const EXPORT_FORMATS = [
  { value: 'gpx', label: 'GPX waypoints' },
  { value: 'geojson', label: 'GeoJSON' },
  { value: 'csv', label: 'CSV' },
  { value: 'shapefile', label: 'Shapefile' }
];
export const EXPORT_DEFAULT_FORMAT = 'gpx';
